import React from 'react'
import classnames from 'classnames'
import './Field.css'

const Field = ({
  children = '',
  error = '',
  className = '',
  ...props
}: any) => (
  <div
    className={classnames('field', { error: !!error }, className)}
    {...props}>
    {children}
  </div>
)

export default Field
